import request from '../request';
import {RequestPageData, RequestReturnPromise, ResponsePageData} from './type';

/**
 * 学科-列表
 * @returns
 */
export function getXkwSubjects(params: {gradeId: number}) {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/subjectsByGradeId',
    params,
  });
}

/**
 * 年级-列表 /api-answer-card/xkw/xopqbm/grades
 * @returns
 * @param params
 */
export function getXkwGrades(params = {}) {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/grades',
    params,
  });
}

/**
 * 教材（章节）目录-获取指定教材的章节树 /api-answer-card/xkw/xopqbm/textbooks/catalog-tree
 * @returns
 * @param params
 */
export function getXkwTextbooksCatalogTree(params: UpdateXkwInfoParams) {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/textbooks/catalog-tree-byProperties',
    params,
  });
}

/**
 * 知识树-获取指定课程的精简版-树 /api-answer-card/xkw/xopqbm/courses/courses/knowledge-points/lite-tree
 * @returns
 * @param params
 */
export function getXkwCoursesKnowledgePointsLiteTree(params: {
  subject_id: number;
  grade_id: number | undefined;
  tags: string;
}) {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/courses/courses/knowledge-points/lite-tree-byProperties',
    params,
  });
}

/**
 * 试题推送-章节-知识点-同步练习 /api-answer-card/xkw/xopqbm/questions/listForStudySkills
 * @param {number} params.grade_id 年级ID
 * @param {number} params.subject_id 学科ID
 * @param {string} params.sceneTemplate 练习场景（目标），afterClass-课后作业，previewClass-课前预习，seatClass-课堂练习
 * @param {array} params.kpoint_ids 试题知识点ID集合，最多传10个，超过的部分会被截取掉；如果传知识点父节点，也会搜索出其子节点中的试题
 * @param {array} params.catalog_ids 章节ID集合，最多传10个，超过的部分会被截取掉；如果传章节父节点，也会搜索出子节点中的试题
 * @param {array} params.difficulty_levels 试题难度等级ID集合（17 容易 18 较易 19 一般 20 较难 21 困难），最多传5个
 * @param {string} params.formula_pic_format 公式图片格式，支持两种：png或svg，默认是svg
 * @param {array} params.en_word_ids 单词ID集合，最多传10个，超过的部分会被截取掉
 * @returns
 * @param data
 */
export function getXkwQuestionsListForStudySkills(data: any) {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/questions/getForStudySkills',
    data,
  });
}

export function getXkwQuestionsListChangeForStudySkills(data: any) {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/questions/changeForStudySkills',
    data,
  });
}

export interface CoursesTextbookVersions_1Res {
  id: number;

  /*节点名称 */
  name: string;

  /*节点类型，分为实节点和虚节点（真实教材目录不存在的节点，例如：单元综合与测试）,可用值:VIRTUAL,REAL */
  type: string;

  /*父节点ID */
  parent_id: number;

  /*教材ID */
  textbook_id: number;

  /*排序值 */
  ordinal: number;

  /*创建时间 */
  create_time: string;

  /*修改时间 */
  update_time: string;
} // /api-answer-card/xkw/xopqbm/courses/courses/textbook-versions-byGradeIdAndSubjectId
export function getXkwTextbookVersionsByGradeIdAndSubjectId(params: {
  gradeId: number;
  subjectId: number;
}): RequestReturnPromise<CoursesTextbookVersions_1Res[]> {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/courses/courses/textbook-versions-byGradeIdAndSubjectId',
    params,
  });
}

export interface XKWTermsRes {
  /*学期ID */
  id: string;

  /*学期名称 */
  name: string;
}

// 获取学期 /api-answer-card/xkw/xopqbm/terms
export function getXkwTerms(): RequestReturnPromise<XKWTermsRes[]> {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/terms',
  });
}

// 试题文件生成 /api-answer-card/xkw/xopqbm/questions/file/generate
export interface FileGenerateParams {
  /*应用方提供的回调地址，文件生成后会通过POST方法回调该地址，Body的数据格式是JSON：requestId-请求标识；url-文件下载地址；status-0 失效 1 文件生成中 2 文件生成成功 3 文件生成失败；msg-数据说明。如果不设置则不会回调 */
  callback_url?: string;

  /*文件副标题 */
  sub_title?: string;

  /*答案的位置：0 仅题目 1 题目答案合一起 2 题目答案分开 3 仅答案，默认为2,可用值:0,1,2,3 */
  answer_position?: number;

  /*文件标题 */
  title?: string;

  /*是否预留作答区域：true 需要 false 不需要，默认为false */
  with_answer_area?: boolean;

  /*试题ID列表（最多支持30题） */
  question_ids?: string[];

  /*文件格式：docx、doc、pdf，默认为docx,可用值:docx,doc,pdf */
  file_format?: string;
}

// 响应接口
export interface FileGenerateRes {
  /*请求标识ID */
  request_id: string;
}

export function fetchXkwQuestionsFileGenerate(
  data: FileGenerateParams,
): RequestReturnPromise<FileGenerateRes> {
  return request({
    method: 'post',
    url: '/api-answer-card/xkw/xopqbm/questions/file/generate',
    data,
  });
}

// 获取试题文件 url /api-answer-card/xkw/xopqbm/questions/file/url
// 参数接口
export interface FileUrlParams {
  /*请求标识ID */
  request_id?: string;
}

export function getXkwQuestionsFileUrl(
  data: FileUrlParams,
): RequestReturnPromise<{
  status: number;
  url: string;
}> {
  return request({
    method: 'post',
    url: '/api-answer-card/xkw/xopqbm/questions/file/url',
    data,
  });
}

// 更新学科网偏好设置 /api-internet-user/mp/ai/user/updateXkwInfo
export interface UpdateXkwInfoParams {
  /*年级ID */
  grade_id?: number;

  /*学期 */
  term?: string;

  /*学科ID */
  subject_id?: number;

  /*教材版本ID */
  version_id?: number;
}

export function updateXkwInfo(data: UpdateXkwInfoParams) {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/ai/user/updateXkwInfo',
    data,
  });
}

// 我的学案列表 /api-answer-card/mp/xkw/user/generate/record/pageGenerateDay
export interface PageGenerateDayRes {
  /*generateDay */
  generateDay: number;

  /*generateRecordCount */
  generateRecordCount: number;

  /*questionSum */
  questionSum: number;

  /*generateRecords */
  generateRecords: PageGenerateRecordParams[];
}

export interface PageGenerateRecordParams {
  // 试题标题
  title: string;
  moduleType: string;
  /*ID */
  id: number;

  /*用户ID */
  userId: number;

  /*调用的API */
  generateApi: string;

  /*API调用次数 */
  apiCallTimes: number;

  /*练习场景（目标），afterClass-课后作业，previewClass-课前预习，seatClass-课堂练习 */
  sceneType: string;

  /*试卷ID */
  paperId: string;

  /*试题数量 */
  questionCount: number;

  /*试题列表 */
  questionIds: Record<string, unknown>[];

  /*年级ID */
  gradeId: number;

  /*学科ID */
  subjectId: number;

  /*学段ID */
  stageId: number;

  /*课程ID */
  courseId: number;

  /*学期枚举:NEXT,LAST,ALL */
  term: string;

  /*试卷等级标签，可传入多个值，1 严选 2 名校 3 教研室 4 真题 5 模拟题 */
  paperLevels: Record<string, unknown>[];

  /*试题知识点ID集合，最多传10个，超过的部分会被截取掉；如果传知识点父节点，也会搜索出其子节点中的试题 */
  kpointIds: Record<string, unknown>[];

  /*章节ID集合，最多传10个，超过的部分会被截取掉；如果传章节父节点，也会搜索出子节点中的试题 */
  catalogIds: Record<string, unknown>[];

  /*试题难度等级ID集合（17 容易 18 较易 19 一般 20 较难 21 困难） */
  difficultyLevels: Record<string, unknown>[];

  /*操作状态，废弃-discarded，待下载-generated，待提交-downloaded，已完成-completed */
  operationStatus: string;

  /*生成日期 */
  generateDay: number;

  /*创建时间 */
  generateTime: Record<string, unknown>;

  /*下载时间 */
  downloadTime: Record<string, unknown>;

  /*完成时间 */
  completedTime: Record<string, unknown>;

  /*请求标识，通过该请求标识获取文件的下载地址，过期时间为24小时 */
  requestId: string;

  /* */
  requestValidTime: Record<string, unknown>;

  /* */
  revision: number;

  /* */
  grade: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  };

  /* */
  subject: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  };

  /* */
  stage: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  };

  /* */
  course: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  };

  /*公式图片格式，支持两种：png或svg，默认是svg */
  formula_pic_format: string;

  /*单词ID集合，最多传10个，超过的部分会被截取掉 */
  en_word_ids: Record<string, unknown>[];
}

export function getXkwUserGenerateRecordPageGenerateDay(
  params: RequestPageData<{moduleType: string}>,
): RequestReturnPromise<ResponsePageData<PageGenerateDayRes>> {
  return request({
    method: 'get',
    url: '/api-answer-card/mp/xkw/user/generate/record/pageGenerateDay',
    params,
  });
}

// /api-answer-card/mp/xkw/user/generate/record/file/url
export function downloadXkwUserGenerateRecordFileUrl(data: {
  generateRecordId: number;
}) {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/user/generate/record/file/url',
    data,
  });
}
// /api-answer-card/mp/xkw/papers/file/url
export function downloadXkwPapersFileUrl(data: GetPaperDetailParams) {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/papers/file/url',
    data,
  });
}

// 根据记录id 获取试题详情 /api-answer-card/mp/xkw/questions/listByGenerateRecordId
export function getXkwQuestionsListByGenerateRecordId(params: {
  generateRecordId: number;
}) {
  return request({
    method: 'get',
    url: '/api-answer-card/mp/xkw/questions/listByGenerateRecordId',
    params,
  });
}

export interface PapersForPhaseTestingParams {
  /*年级ID */
  grade_id?: number;

  /*教材版本ID */
  version_id?: number;

  /*课程ID，非必传，不传则表示全部课程 */
  subject_id?: number;

  /*学期枚举:NEXT,LAST,ALL */
  term?: string;

  /*章节ID集合，最多传10个，超过的部分会被截取掉；如果传章节父节点，也会搜索出子节点中的试题 */
  catalog_ids?: Record<string, unknown>[];

  /*年份，最多传3个，默认2019(含2019)之后 */
  years?: Array<number>;

  /*练习场景（目标），phaseTest-阶段练习，midOfTermTest-期中，endOfTermTest-期末，topicTest-专题练习，beginOfTermTest-开学考试 */
  sceneType?: string | number;

  /*级别，ordinary-普通，quality-精品，special-特供 */
  levelType?: string;
  /*当前页码（从1开始，总计最多返回500条数据；PageIndex超过500，会取值最大值500） */
  page_index?: number;

  /*每页数据条数（默认为10，最大为50） */
  page_size?: number;
  // /*地区ID */
  area_id?: number | string;

  // 查询关键字
  title_keyword?: string;

  practiceType?: string | number;
}

export interface PapersForPhaseTestingResItem {
  /*试卷ID */
  id: string;

  /*课程ID，非必传，不传则表示全部课程 */
  course_id: number;

  /*年份 */
  year: number;

  /*学段ID：1=学前, 2=小学, 3=初中, 4=高中, 5=大学, 6=中职 */
  stage_id: number;

  /*试卷类型ID */
  type_id: number;

  /*教材版本id */
  version_id: number;

  /*标题 */
  title: string;

  /*试卷的章节ID集合 */
  catalog_ids: Record<string, unknown>[];

  /*试卷更新日期 */
  update_date: string;

  /*试卷中试题数量。以具有题号的独立试题为单位统计 */
  question_count: number;

  /*地区ID集合（到区县级） */
  area_ids: string;

  /*年级ID */
  grade_id: number;

  /*学校ID */
  org_id: number;

  /*学校名称 */
  org_name: string;

  /*学期枚举:NEXT,LAST,ALL */
  term: string;

  /*试卷入库日期 */
  create_date: string;

  /*试卷等级标签，包含：严选、名校、教研室、真题、模拟题。其中，严选试卷：指经过教研老师严格审核过的高质量试卷；名校试卷：指来源于百强校、省重点、市重点学校的试卷；教研室试卷：指来源于省级/市级/区县级教研室命题的试卷；真题试卷：指小升初、中考、高考真题试卷；模拟题试卷：指小升初、中考、高考模拟试卷，普通试卷不包含此类型 */
  levels: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  }[];
}

export interface PapersForPhaseTestingRes {
  /*当前页码（从1开始） */
  page_index: number;

  /*每页记录数 */
  page_size: number;

  /*总页数 */
  total_page: number;

  /*总记录数 */
  total_size: number;

  /*本页数据 */
  items: PapersForPhaseTestingResItem[];
}

// /api-answer-card/mp/xkw/papers/getForPhaseTesting 试卷分页查询-阶段测评
export function getXkwPapersGetForPhaseTesting(
  data: PapersForPhaseTestingParams,
): RequestReturnPromise<PapersForPhaseTestingRes> {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/papers/getForPhaseTesting',
    data,
  });
}

// /api-answer-card/mp/xkw/papers/getForClassicPapers
export function getXKWPapersGetForClassicPapers(
  data: PapersForPhaseTestingParams,
): RequestReturnPromise<PapersForPhaseTestingRes> {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/papers/getForClassicPapers',
    data,
  });
}
// /api-answer-card/mp/xkw/papers/getForEnrolmentPapers
export function getXKWPapersGetForEnrolmentPapers(
  data: PapersForPhaseTestingParams,
): RequestReturnPromise<PapersForPhaseTestingRes> {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/papers/getForEnrolmentPapers',
    data,
  });
}

export interface PapersTypesItem {
  /*难度ID */
  id: number;

  /*难度名称 */
  name: string;

  /*难度档上限值 */
  ceiling: Record<string, unknown>;

  /*难度档下限值 */
  flooring: Record<string, unknown>;
}

// /api-answer-card/xkw/xopqbm/paper-types 获取试卷类型
export function getXkwPaperTypes(): RequestReturnPromise<PapersTypesItem[]> {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/paper-types',
  });
}

// 获取试卷详情 /api-answer-card/mp/xkw/papers/getPaperDetail
export interface GetPaperDetailParams {
  /* */
  paper_id?: string;

  /* */
  sceneType?: string;

  /* */
  grade_id?: number;

  /* */
  subject_id?: number;

  /* */
  catalog_ids?: Record<string, unknown>[];

  /* */
  formula_pic_format?: string;

  /* */
  moduleType?: string;
}

export interface GetPaperDetailResQuestion {
  /* */
  typeSort: number;

  /*试题ID */
  id: string;

  /*试题类型ID */
  type_id: string;

  /* */
  type: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  };

  /*课程ID */
  course_id: number;

  /* */
  course: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  };

  /*试题难度等级（17 容易，18 较易，19 一般，20 较难，21 困难） */
  difficulty_level: number;

  /*试题难度，0~1之间的数字，值越小难度越大（(0.9,1] 容易，(0.8,0.9] 较易，(0.5,0.8] 一般，(0.3,0.5] 较难，[0, 0.3] 困难） */
  difficulty: Record<string, unknown>;

  /*知识点ID列表 */
  kpoint_ids: Record<string, unknown>[];

  /*知识点列表 */
  kpoints: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  }[];

  /*试题是否包含媒体内容（0 没有，1 有音频 2 有解题视频 3 音频和解题视频都有；解题视频不在试题中输出，请通过"获取解题视频"接口获取） */
  media: number;

  /*解题视频封面（一个解题视频对应一个封面，如果没有则为空；一般只有一个解题视频） */
  exp_video_posters: Record<string, unknown>[];

  /*试题解析（HTML格式），请参考《试题结构和HTML渲染说明文档》 */
  explanation: string;

  /*试题出现在试卷中的年份，可能多个 */
  years: Record<string, unknown>[];

  /*在线作答（0 不支持，1 支持）；选择题或者打标了机阅的试题 */
  answer_scoreable: number;

  /*标签ID列表 */
  tag_ids: Record<string, unknown>[];

  /*标签列表 */
  tags: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  }[];

  /*动态试题ID，无过期时间 */
  dynamic_id: string;

  /*试卷类型ID列表 */
  paper_type_ids: Record<string, unknown>[];

  /*教材目录ID列表 */
  catalog_ids: Record<string, unknown>[];

  /*教材目录列表 */
  catalogs: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  }[];

  /*单词列表，可通过"单词查询"接口获取单词的详细信息 */
  en_words: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  }[];

  /*试题答案（HTML格式），请参考《试题结构和HTML渲染说明文档》 */
  answer: string;

  /*单词ID列表 */
  en_word_ids: Record<string, unknown>[];

  /*试题题干（HTML格式），请参考《试题结构和HTML渲染说明文档》 */
  stem: string;

  /* */
  source_papers: {
    /* */
    area: {
      /*ID */
      id: string;

      /*名称 */
      name: string;
    };

    /*试卷名称 */
    title: string;
  };

  /*试题入库日期 */
  create_date: string;
}

export interface GetPaperDetailRes {
  /*生成记录ID */
  generateRecordId: string;

  /*试卷ID */
  id: string;

  /*标题 */
  title: string;

  /*年份 */
  year: number;

  /*试卷等级标签，1 严选 2 名校 3 教研室 4 真题 5 模拟题 */
  levels: {
    /*ID */
    id: string;

    /*名称 */
    name: string;
  }[];

  /*学段ID：1=学前, 2=小学, 3=初中, 4=高中, 5=大学, 6=中职 */
  stage_id: number;

  /*年级ID */
  grade_id: number;

  /*教材版本id */
  version_id: number;

  /*课程ID */
  course_id: number;

  /*试卷类型ID */
  type_id: number;

  /*学期,可用值:LAST,NEXT,ALL */
  term: string;

  /*学校ID */
  org_id: number;

  /*学校名称 */
  org_name: string;

  /*试卷的章节ID集合 */
  catalog_ids: Record<string, unknown>[];

  /*地区ID集合（到区县级） */
  area_ids: Record<string, unknown>[];

  /*试卷更新日期 */
  create_date: string;

  /*试卷更新日期 */
  update_date: string;

  /*试卷结构html，内有试题占位符 */
  paper_struct_html: string;

  /*试卷中试题数量。以具有题号的独立试题为单位统计 */
  question_count: number;

  /*试题列表 */
  questions: GetPaperDetailResQuestion[];
}

export function getXkwPapersGetPaperDetail(
  data: GetPaperDetailParams,
): RequestReturnPromise<GetPaperDetailRes> {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/papers/getPaperDetail',
    data,
  });
}

// /api-answer-card/xkw/xopqbm/papers/v2/paper-download
export function downloadXKWXopqbmPaperV2PaperFile(params: {id: string}) {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/papers/v2/paper-download',
    params,
  });
}

// /api-answer-card/mp/xkw/papers/getByGenerateRecordId
export function getXkwPapersGetByGenerateRecordId(params: {
  generateRecordId: number;
}): RequestReturnPromise<GetPaperDetailRes> {
  return request({
    method: 'get',
    url: '/api-answer-card/mp/xkw/papers/getByGenerateRecordId',
    params,
  });
}
// 获取试卷详情 30%图片 /api-answer-card/mp/xkw/papers/preview
export interface GetXkwPapersPreviewRes {
  urls: string[];
  total_count: number;
  count: number;
  type: string;
}
export function getXkwPapersPreview(params: {
  paperId: string;
}): RequestReturnPromise<GetXkwPapersPreviewRes> {
  return request({
    method: 'get',
    url: '/api-answer-card/mp/xkw/papers/preview',
    params,
  });
}

///api-answer-card/xkw/xopqbm/subjects
export function getXkwXopqbmSubjects() {
  return request({
    method: 'get',
    url: '/api-answer-card/xkw/xopqbm/subjects',
  });
}
